import { CssBaseline, ThemeProvider } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthContext, AuthProvider } from './AuthContext';
import { NetworkProvider } from './NetworkProvider';
import NetworkBanner from './component/NetworkBanner';
import SessionExpiredDialog from './component/SessionExpiredDialog';
import ScrollToTop from './component/shared/ScrollToTop';
import RTL from './layouts/full/shared/customizer/RTL';
import Router from './routes/Router';
import { ThemeSettings } from './theme/Theme';
import Footer from './component/Footer';
import socket from './utils/socket';

function AppContent() {
  const { isAuthenticated } = useContext(AuthContext);
  const routing = useRoutes(Router);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginRedirect = () => {
    navigate('/auth/login');
  };

  const isLoginPage =
    location.pathname.startsWith('/auth/login') ||
    location.pathname.startsWith('/auth/forget-password') ||
    location.pathname.startsWith('/auth/reset-password');

  return (
    <>
      <NetworkBanner />
      {routing}
      <SessionExpiredDialog open={!isAuthenticated && !isLoginPage} onLogin={handleLoginRedirect} />
    </>
  );
}

function App() {
  const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  // useEffect(() => {
  //   if (Object.keys(userDetails).length > 0) {
  //     socket.on('connect', () => {
  //       socket.emit('user:connect', { userId: userDetails.id, socketId: socket.id });
  //     });

  //     socket.on('confirm:booking', (data) => {
  //       let notification = new Notification('New Reservation Confirmed', {
  //         body: data.message,
  //         icon: '/android-chrome-192x192.png', // optional
  //         badge: '/android-chrome-512x512.png', // optional
  //         requireInteraction: true, // optional
  //       });

  //       notification.onclick = () => {
  //         window.focus();
  //       };
  //     });
  //   }

  //   return () => {
  //     socket.off('confirm:booking');
  //   };
  // }, []);

  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <NetworkProvider>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <RTL direction={customizer.activeDir}>
            <CssBaseline />
            <ScrollToTop>
              <AppContent />
            </ScrollToTop>
          </RTL>
          <ToastContainer />
          <Footer />
        </ThemeProvider>
      </AuthProvider>
    </NetworkProvider>
  );
}

export default App;
